<template>
  <v-card-text>
    <div
      v-for="mode in modes"
      :key="mode.value"
      class="mb-2"
    >
      <v-btn
        text
        large
        class="text-none"
        @click="$emit('select', mode.value)"
      >
        <v-icon
          size="28"
          left
          :color="mode.color"
          v-text="icons[`cash${mode.value}`]"
        />
          {{ __(`cash${mode.value}`) }}
      </v-btn>
    </div>
  </v-card-text>
</template>

<script>
  import I18n from '@/Mixins/I18n'
  import UsesIcons from '@/Mixins/UsesIcons'
  import InOutMode from '@/Models/Static/InOutMode'

  export default {
    mixins: [
      I18n,
      UsesIcons,
    ],

    data: () => ({
      modes: [
        { value: InOutMode.IN, color: 'success' },
        { value: InOutMode.OUT, color: 'primary' },
      ],
    }),
  }
</script>
